import { Component,  Vue, Watch} from 'vue-property-decorator'
import { CsvDownload } from '@/types/APIResponse';
import {shippingDestinationMonthlySale,ShippingDestinationList,CropList,MonthlySalesSelectedItems} from "@/types/Component"
import VerticalBarChart from '@/assets/common/VerticalBarChart/VerticalBarChart.vue';
import EmptyGraphMessage from '@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue';

import moment from 'moment';

@Component({
    components: {
        VerticalBarChart,
        EmptyGraphMessage
    }
  })
export default class ShippingDestinationMonthlySales extends Vue {
    title = '売上実績（月別）'
    baseUrl = '/shippingMonthlysales';
    selectScreenManagement = '/graphScreenManagement';
    shippingDestinationMonthlyList= [] as shippingDestinationMonthlySale;
    private monthlySaleSelectedItems= {} as MonthlySalesSelectedItems;

    private selectedDestinationId = null;
    private selectedCropId = null;
    private startDateInput :any ='' ;
    private endDateInput :any = '';
    private startDate: any ='';
    private endDate: any= '';
    private maxAmount :any= null;
    private selectedShippingDestinationName = "" as any;
    private selectedCropName = "" as any;
    
    private selectedYearAmountArr :any []= [];
    private previousYearAmountArr :any[]= [];
    private monthsArray :any []=[];
    private selectedYearAmount:any = [];
    private previousYearAmount :any= [];
    private monthsArr :any= [];
    private dataset1 :any =[]
    private dataset2 :any =[]
    private shippingDestinationList = [] as ShippingDestinationList[];
    private cropList =[] as CropList;
    private monthRange:any =''
    private getSystemDate = new Date();
    private currentYear:any= ''
    private pastYear:any = ''
    private futureYear:any = ''
    private dataEmptyFlag = false;
    includeHiddenFlag = false;

    private created() {
        this.currentYear = this.getSystemDate.getFullYear()
        this.pastYear = this.getSystemDate.getFullYear()-1
        this.startDateInput = this.currentYear + "-01"
        this.endDateInput = this.currentYear + "-12"
        this.startDate = this.startDateInput
        this.endDate = this.endDateInput
        this.getShippingMonlthlySales()
        this.setChartdatas()
        this.getShippingDestinations()
        this.getCrops()
    }

    public getShippingMonlthlySales() {
        this.$apiClient.doRequest('get', `${this.baseUrl}`).then(ret => {
        this.shippingDestinationMonthlyList =ret.monthlySales
        this.monthlySaleSelectedItems =ret.selectedItems
        if (this.monthlySaleSelectedItems != null ){
          this.defaultSelectItems(this.monthlySaleSelectedItems)
        }
        this.chartDataMapFunction(this.shippingDestinationMonthlyList)
        this.currentYear = Number(this.startDateInput.split("-")[0]);
        this.pastYear = Number(this.startDateInput.split("-")[0] - 1);
        this.futureYear = Number(this.endDateInput.split("-")[0]);
        this.dataEmptyFlag =true;
        }).catch(error=>{
          this.$toasted.error('取得に失敗しました')
        })
    }

    private amountValidate(){
      const maxAmount =Math.max( ...this.selectedYearAmountArr.concat(this.previousYearAmountArr));
      if (this.maxAmount.toString().length > 10) {
        window.alert("「最大10桁までの金額を入力してください。」");
        this.maxAmount = null;
      }else if(maxAmount>this.maxAmount && this.maxAmount != ''){
        window.alert("「目盛の最大金額より小さいです。」");
        this.maxAmount = null;
      }
      else{
        this.handleSelectChange();
      }
    }

    private chartDataMapFunction (shippingDestinationMonthlyList:any){
      this.dataset1 = shippingDestinationMonthlyList
          .filter((item :any) => new Date(item.month).getFullYear() === this.currentYear)
          .map((item:any) => ({
                month:item.month.split('-')[1],
                monthlyShippingAmount:item.monthlyShippingAmount
          }));
      this.dataset2 = shippingDestinationMonthlyList
          .filter((item :any) => new Date(item.month).getFullYear() === this.pastYear)
          .map((item:any) => ({
                month:item.month.split('-')[1],
                monthlyShippingAmount:item.monthlyShippingAmount
          }));
      const monthDataProcess=shippingDestinationMonthlyList.map((item:any)=>{
            const startDate = new Date(this.startDateInput);
            const endDate = new Date(this.endDateInput);
            const startMonth = startDate.getMonth()+1;
            const endMonth = endDate.getMonth()+1;
            const startIndex = startMonth ?startMonth : 1;
            const endIndex =  endMonth ? endMonth : 12 ;
            const selectedYearAmount=[];
            const previousYearAmount=[];
           
            const monthArr=[]
            //If Different Period of Year Selected
            if(startDate.getFullYear() != endDate.getFullYear()){
              const selectedYear= startDate.getFullYear();
              const previousYear= startDate.getFullYear()-1;
              const futureYear = startDate.getFullYear()+1;
              const currentYearStartIndex = startDate.getFullYear()+ "-" +  startDate.getMonth().toString().padStart(2 ,'0');
              const currentYearEndIndex = endDate.getFullYear()+ "-"+ endDate.getMonth().toString().padStart(2 ,'0');
              //get month of startYear
              for(let i = startIndex;i<=12;i++){
                const month = i.toString().padStart(2 ,'0');
                  const previousMonthData = this.shippingDestinationMonthlyList.find(item =>item.month === `${previousYear}-${month}`);
                  previousYearAmount.push(previousMonthData ? Number(previousMonthData.monthlyShippingAmount) : 0);
                  const selectedMonthData = this.shippingDestinationMonthlyList.find(item => item.month === `${selectedYear}-${month}`);
                  selectedYearAmount.push(selectedMonthData ? Number(selectedMonthData.monthlyShippingAmount) : 0);
                  monthArr.push(i)
              }
              //get months of endYear
              for(let i=1;i<=endIndex;i++){
                const month = i.toString().padStart(2 ,'0');
                const previousMonthData = this.shippingDestinationMonthlyList.find(item => item.month === `${selectedYear}-${month}`);
                previousYearAmount.push(previousMonthData ? Number(previousMonthData.monthlyShippingAmount) : 0);
                const selectedMonthData = this.shippingDestinationMonthlyList.find(item => item.month === `${futureYear}-${month}`);
                selectedYearAmount.push(selectedMonthData ? Number(selectedMonthData.monthlyShippingAmount) : 0);
                monthArr.push(i)
                
              }
              // same periods of year 
            } else {
              const selectedYear= startDate.getFullYear();
              const previousYear= startDate.getFullYear()-1;
              for(let i = startIndex;i<=endIndex;i++){
                const month = i.toString().padStart(2 ,'0');
                const selectedMonthData = this.shippingDestinationMonthlyList.find(item => item.month === `${selectedYear}-${month}`);
                const previousMonthData = this.shippingDestinationMonthlyList.find(item => item.month === `${previousYear}-${month}`);
                selectedYearAmount.push(selectedMonthData ? Number(selectedMonthData.monthlyShippingAmount) : 0);
                previousYearAmount.push(previousMonthData ? Number(previousMonthData.monthlyShippingAmount) : 0);
                monthArr.push(i)
              }
            }
            this.selectedYearAmountArr = selectedYearAmount;
            this.previousYearAmountArr = previousYearAmount;
            this.monthsArray = monthArr
      })
    }

    //sorting 
    compareNumbers(a:any, b:any) {
      return a - b;
    }

    private chartData:any={}
    private options:any={}

    @Watch("shippingDestinationMonthlyList")
    private setChartdatas ():void{
      const maxAmount =Math.max( ...this.selectedYearAmountArr.concat(this.previousYearAmountArr))*1.2;
      const roundedMaxAmount =this.roundUpNumber(maxAmount);
      const startDate = new Date(this.startDateInput);
      const endDate = new Date(this.endDateInput);
      this.chartData={
          labels:this.monthsArray,
          datasets: [
            {
              label: startDate.getFullYear() == endDate.getFullYear() ? this.pastYear +"年":this.pastYear +"年" +"-" +this.currentYear +"年" ,
              type: 'line',
              borderColor: '#FF6E53',
              borderWidth: 2,
              lineTension: 0,
              fill: false,
              data: this.previousYearAmountArr
            },
            {
              type: 'bar',
              label: startDate.getFullYear() == endDate.getFullYear() ? this.currentYear+"年" : this.currentYear +"年" +"-" +this.futureYear +"年",
              borderColor: '#71A0D8',
              backgroundColor: '#71A0D8',
              data: this.selectedYearAmountArr,
              barPercentage: 0.4
            }
          ]
      }
      this.options={
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks:{
            title:function(tooltipItem:any,data:any){
              return data.datasets[tooltipItem[0].datasetIndex].label +" "+tooltipItem[0].label+"月"
            },
            label:function (tooltipItem: any, data: any){
              const amount = Number(tooltipItem.value)
              return amount.toLocaleString('ja-JP')+"円"
            }
          }
        },
        scales:{
          xAxes:[{
            ticks:{
                callback:(value:any)=>{
                    return value+"月"
                }
            }
          }],
          yAxes:[{
            ticks:{
              beginAtZero:true,
              suggestedMax: this.maxAmount==null? roundedMaxAmount :this.maxAmount,
              stepSize:this.maxAmount==null ? roundedMaxAmount /5 :this.maxAmount/5,
              callback:(value:any)=>{
                return value.toLocaleString('ja-JP')+"円"
              }
            }
          }]
        },
        legend:{
          position:"bottom"
        },    
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 20,
            bottom: 0
          }
        },
      }
    }

  private defaultSelectItems(slectedItems :any){
    // Convert the string to a JavaScript Date object
    const startDateObject = new Date(slectedItems.displayFromDate?slectedItems.displayFromDate:this.startDateInput);
    const endDateObject = new Date(slectedItems.displayToDate?slectedItems.displayToDate:this.endDateInput);
    // Format the date as YYYY-MM (without the day)
    const formattedStartDate = startDateObject.toISOString().slice(0, 7);
    const formattedendDate = endDateObject.toISOString().slice(0, 7);
    this.selectedDestinationId =slectedItems.shippingDestinationId
    this.selectedCropId =slectedItems.cropId
    this.startDateInput= formattedStartDate
    this.endDateInput=formattedendDate
    this.startDate = formattedStartDate
    this.endDate = formattedendDate
    this.maxAmount=slectedItems.maximumAmount
    this.includeHiddenFlag = slectedItems.includeHiddenFlag
  }

  private roundUpNumber(num: number): number {
    const stringValue = num.toString();
    const restOfTheNumber = parseInt(stringValue.substring(2));
    if (restOfTheNumber === 0) {
      return num; 
    }
    const roundedNum = Math.pow(10, Math.floor(Math.log10(num))) * Math.ceil(num / Math.pow(10, Math.floor(Math.log10(num))));
    if (roundedNum === num) {
      return num; 
    }
    return roundedNum;
  }

getShippingDestinations() {
     this.$apiClient.doRequest('get', `/admin/shipping_destinations?with_hidden=true`).then(ret => {
     this.shippingDestinationList = ret.shipping_destinations.sort((a:any,b:any) => a.name.localeCompare(b.name));
     this.selectedShippingDestinationName= this.shippingDestinationList.find(item=>item.id==this.selectedDestinationId)?.name
     })
 }

getCrops() {
     this.$apiClient.doRequest('get', `/crops/cropBytenentId`).then(ret => {
     this.cropList = ret.crops;
     this.cropList.sort((a:any, b:any) => a.name.localeCompare(b.name));
     this.selectedCropName = this.cropList.find(item=>item.id==this.selectedCropId)?.name
     })
 }

 private handleSelectChange(flag = true) {  
   this.selectedShippingDestinationName= this.shippingDestinationList.find(item=>item.id==this.selectedDestinationId)?.name
   this.selectedCropName = this.cropList.find(item=>item.id==this.selectedCropId)?.name
   const momentStartDate = moment(this.startDateInput);
   const momentEndDate = moment(this.endDateInput);
   const firstDayOfMonth = momentStartDate.startOf('month').format('YYYY-MM-DD');
   const lastDayOfMonth = momentEndDate.endOf('month').format('YYYY-MM-DD');

   const params = {
     destinationId: this.selectedDestinationId,
     cropId: this.selectedCropId,
     startDate: firstDayOfMonth,
     endDate: lastDayOfMonth,
     amount: this.maxAmount,
     screenName:'MONTHLYSALES',
     includeHiddenFlag: this.includeHiddenFlag
     }
     this.$apiClient.doRequest('post', `${this.selectScreenManagement}`,params).then(ret => {
      if (flag) {
        this.getShippingMonlthlySales();
      }
     })
 }


 // Move the date range forward
 private moveForward() {
  // Convert the input date string to a Date object
  const inputStartDate = new Date(this.startDateInput + "-01"); 
  const inputendDate = new Date(this.endDateInput + "-01"); 
  
  inputStartDate.setFullYear(inputStartDate.getFullYear() + 1);
  inputendDate.setFullYear(inputendDate.getFullYear() + 1);

  // Get the updated date in YYYY-MM format
  this.startDateInput = inputStartDate.toISOString().slice(0, 7);
  this.endDateInput = inputendDate.toISOString().slice(0, 7); 
  this.handleSelectChange();
 }
 // Move the date range backward by one month
private moveBackward() {
 // Convert the input date string to a Date object
  const inputStartDate = new Date(this.startDateInput + "-01"); 
  const inputendDate = new Date(this.endDateInput + "-01"); 

  inputStartDate.setFullYear(inputStartDate.getFullYear() - 1);
  inputendDate.setFullYear(inputendDate.getFullYear() - 1);

  // Get the updated date in YYYY-MM format
  this.startDateInput = inputStartDate.toISOString().slice(0, 7);
  this.endDateInput = inputendDate.toISOString().slice(0, 7); 
  this.handleSelectChange();
 }

 validateStartDates() {
  const startDate = new Date(this.startDateInput);
  startDate.setMonth(startDate.getMonth() + 11);
  
  const year = startDate.getFullYear();
  const month = (startDate.getMonth() + 1).toString().padStart(2, '0');
  const endDateValue = `${year}-${month}`;
  
  this.endDateInput = endDateValue;
  this.handleSelectChange();

}
 validateEndDates(){
  const endDate = new Date(this.endDateInput);
  endDate.setMonth(endDate.getMonth() - 11);
  
  const year = endDate.getFullYear();
  const month = (endDate.getMonth() + 1).toString().padStart(2, '0');
  const startDateValue = `${year}-${month}`;
  
  this.startDateInput = startDateValue;
  this.handleSelectChange();
 }

  exportCsv() {
    this.$apiClient.getRequest( `${this.baseUrl}/csv_export?start_date=${this.startDateInput}&end_date=${this.endDateInput}&shipping_destination_name=${this.selectedShippingDestinationName?this.selectedShippingDestinationName:""}&crop_name=${this.selectedCropName?this.selectedCropName:""}`).then((res: CsvDownload) => {
        this.$apiClient.csvDownload(res)
    })
  }

  get filterShippingDestinationList() {
    return this.includeHiddenFlag ? this.shippingDestinationList : this.shippingDestinationList.filter(s => this.selectedDestinationId == s.id || !s.is_hidden);
  } 
}